import IServiceCoursesProvider from "./ServiceCoursesProvider";
import axios from "axios";
import { AxiosRequestConfig, AxiosResponseHeaders } from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { IMsalContext } from "@azure/msal-react";
import { loginRequest } from "AuthConfig";

const featuredCourses = [
    {
        id: "c414d939-faf0-ed11-8848-0022483d05a3",
        titreLong: {
            fr: "Leader à l'ère numérique et du changement 365",
            en: "Leader in the digital age and 365 change"
        },
        formateur: "Stefan Lamoureux",
        description: {
            fr: "Découvrez les gestes clés à développer pour créer et développer une culture numérique efficace dans vos équipes.\n Découvrez les valeurs importantes du leader d'aujourd'hui naviguant dans un environnement complexe (VUCA - volatile, incertain, complexe et ambigu).\n Découvrez comment augmenter la collaboration et l'agilité dans vos équipes avec l'écosystème Microsoft 365.",
            en: "Line 1\n Line2\n Line3"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Leader-2.jpg",
        categoriePrincipale: {
            id: "244595b5-8bc5-ec11-a7b5-000d3a8448ed",
            titre:{
                fr: "Compétences humaines et leadership",
                en: "Leadership and Human Skills"
            }
        },
        duration: "90 minutes",
        dateSession: "2023-11-28T12:00:00"
    },
    {
        id: "a1268b25-fef0-ed11-8848-0022483d0128",
        titreLong: {
            fr: "Trucs et astuces pour communiquer efficacement avec Teams",
            en: "Tips and tricks for communicating effectively with Teams"
        },
        formateur: "Pascal Forget",
        description: {
            fr: "Vous vous demandez comment utiliser Teams efficacement, quand utiliser le courriel ou les canaux d'équipes ? Cette formation est pour vous !\n Découvrez pourquoi et quand utiliser la messagerie instantanée, les conversations dans les canaux Teams et le courriel.\n Découvrez pourquoi le courriel ne fait plus seul le travail et que nous devons diversifier nos façons de communiquer pour survivre à la surcharge d’information.\n Découvrez plusieurs trucs et astuces techniques pour mieux gérer vos communications.\n Découvrez comment communiquer efficacement dans Teams, gérer les notifications et suivre les canaux.\n Découvrez comment effectuer des suivis (To Do) sur les messages dans les canaux et clavardage.",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Communication-2.jpg",
        categoriePrincipale: {
            id: "3b4669be-bc0b-ee11-8f6e-0022483d05a3",
            titre:{
                fr: "Compétences en collaboration",
                en: "Collaboration Skills"
            }
        },
        duration: "90 minutes",
        dateSession: "2023-11-29T12:00:00"
    },
    {
        id: "5c17c0b7-b7d4-435e-aca5-ca875906f456",
        titreLong: {
            fr: "Attachez votre ceinture et travaillez en toute sécurité à l'ère du numérique",
            en: "Buckle up and work safely in the digital age"
        },
        formateur: "Stéfan Lamoureux",
        description: {
            fr: "Vous vous demandez comment utiliser Teams efficacement, quand utiliser le courriel ou les canaux d'équipes ? Cette formation est pour vous !\n Découvrez pourquoi et quand utiliser la messagerie instantanée, les conversations dans les canaux Teams et le courriel.\n Découvrez pourquoi le courriel ne fait plus seul le travail et que nous devons diversifier nos façons de communiquer pour survivre à la surcharge d'information.\n Découvrez plusieurs trucs et astuces techniques pour mieux gérer vos communications.\n Découvrez comment communiquer efficacement dans Teams, gérer les notifications et suivre les canaux.\n Découvrez comment effectuer des suivis (To Do) sur les messages dans les canaux et clavardage.",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Ceinture-1.jpg",
        categoriePrincipale: {
            id: "f1bc2288-5bfb-ed11-8f6e-0022483d05a3",
            titre:{
                fr: "Compétences en sécurité numérique",
                en: "Digital security skills"
            }
        },
        duration: "90 minutes",
        dateSession: "2023-11-30T12:00:00"
    },
    {
        id: "6e75fec1-a0be-4335-baba-00c7f7817346",
        titreLong: {
            fr: "Sécurisez et structurez les renseignements personnels des ressources humaines dans Microsoft 365",
            en: "Secure and structure personal human resources information in Microsoft 365"
        },
        formateur: "Valère Drainville",
        description: {
            fr: "Cette formation s'adresse à toute personne qui veut organiser et structurer les fichiers comportant des renseignements personnels et sensibles concernant les employés de votre organisation.\n Vous découvrirez une proposition de structure sécurisée de gestion de fichiers comportant une équipe Teams, des canaux partagés et des bibliothèques SharePoint.\n Vous découvrirez comment une liste SharePoint ou Dataverse avec l'aide Power Automate peut gérer le cycle de vie (archivage, suppression) des fichiers afin de mieux vous conformer à la Loi 25.\n Découvrez plusieurs trucs et astuces techniques pour mieux gérer vos communications.\n Nous en profiterons aussi pour démystifier les étiquettes de confidentialité dans Microsoft",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Security-1.jpg",
        categoriePrincipale: {
            id: "f1bc2288-5bfb-ed11-8f6e-0022483d05a3",
            titre:{
                fr: "Compétences en sécurité numérique",
                en: "Digital security skills"
            }
        },
        duration: "90 minutes",
        dateSession: "2023-12-01T12:00:00"
    }
];

const coursesRes = [
    {
        "id": "3e579810-3035-4466-811a-5856287720a4",
        "titreLong": {
            "fr": "Une formation de test",
            "en": "A test formation"
        },
        "formateur": "Roger Tremblay",
        "categoriePrincipale": {
            "id": "ce867587-df21-4033-bdd1-530a234e5428",
            "titre": {
                "fr": "Catégorie 1",
                "en": "Category 1"
            }
        },
        "description": {
            "fr": "Ceci est une formation de test",
            "en": "This is a test formation"
        },
        "duree": "00:90",
        "Notes": {
            "fr": "Notes sur la formation",
            "en": "Formation notes"
        },
        "dateSession": "2023-12-31T00:00:00",
        "langue": "fr",
        "categories": [
            {
                "Id": "ce867587-df21-4033-bdd1-530a234e5428",
                "Titre": {
                    "fr": "Catégorie 1",
                    "en": "Category 1"
                }
            },
            {
                "Id": "5ab1ab9a-3388-43b2-8c91-7a8e78449c00",
                "Titre": {
                    "fr": "Catégorie 2",
                    "en": "Category 2"
                }
            }
        ],
        "typesAbonnement": [
            {
                "Id": "606b6e3d-9081-46d0-bd69-d27321fc75b3",
                "Titre": {
                    "fr": "Abonnement découverte",
                    "en": "Discovery subscription"
                }
            }
        ]
    },
    {
        "id": "4e882510-2047-4589-9c56-4932e3472f9a",
        "titreLong": {
            "fr": "Formation avancée en développement web",
            "en": "Advanced web development training"
        },
        "formateur": "Alice Johnson",
        "categoriePrincipale": {
            "id": "8a3c4bd3-1d91-4e8d-8e07-59e1e6edf7bf",
            "titre": {
                "fr": "Catégorie 3",
                "en": "Category 3"
            }
        },
        "description": {
            "fr": "Approfondissez vos compétences en développement web avec cette formation avancée.",
            "en": "Enhance your web development skills with this advanced training."
        },
        "duree": "01:30",
        "Notes": {
            "fr": "Prérequis : Connaissance de base en HTML, CSS et JavaScript.",
            "en": "Prerequisites: Basic knowledge of HTML, CSS, and JavaScript."
        },
        "dateSession": "2023-12-25T10:00:00",
        "langue": "en",
        "categories": [
            {
                "Id": "8a3c4bd3-1d91-4e8d-8e07-59e1e6edf7bf",
                "Titre": {
                    "fr": "Catégorie 3",
                    "en": "Category 3"
                }
            },
            {
                "Id": "a1b2c3d4-5678-90ab-cdef-ghij1k2l3m4n",
                "Titre": {
                    "fr": "Catégorie 4",
                    "en": "Category 4"
                }
            }
        ],
        "typesAbonnement": [
            {
                "Id": "9d8e7f6b-5a4c-3d2e-1b0a-9c8d7f6e5b4a",
                "Titre": {
                    "fr": "Abonnement avancé",
                    "en": "Advanced subscription"
                }
            }
        ]
    },
    {
        id: "6e75fec1-a0be-4335-baba-00c7f7817346",
        langue : "fr",
        titreLong: {
            fr: "Sécurisez et structurez les renseignements personnels des ressources humaines dans Microsoft 365",
            en: "Secure and structure personal human resources information in Microsoft 365"
        },
        formateur: "Valère Drainville",
        description: {
            fr: "Cette formation s'adresse à toute personne qui veut organiser et structurer les fichiers comportant des renseignements personnels et sensibles concernant les employés de votre organisation.\n Vous découvrirez une proposition de structure sécurisée de gestion de fichiers comportant une équipe Teams, des canaux partagés et des bibliothèques SharePoint.\n Vous découvrirez comment une liste SharePoint ou Dataverse avec l'aide Power Automate peut gérer le cycle de vie (archivage, suppression) des fichiers afin de mieux vous conformer à la Loi 25.\n Découvrez plusieurs trucs et astuces techniques pour mieux gérer vos communications.\n Nous en profiterons aussi pour démystifier les étiquettes de confidentialité dans Microsoft",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Security-1.jpg",
        categoriePrincipale: {
            id: "f1bc2288-5bfb-ed11-8f6e-0022483d05a3",
            titre:{
                fr: "Compétences en sécurité numérique",
                en: "Digital security skills"
            }
        }, 
        duration: "90 minutes",
        dateSession: "2023-12-01T12:00:00"
    },
    {
        id: "9e55d45b-e5f0-ed11-8848-0022483d0128",
        langue : "fr",
        titreLong: {
            fr: "Démystifiez Microsoft 365 pour augmenter la productivité par une communication et une collaboration efficace",
            en: "Demystify Microsoft 365 to increase productivity through effective communication and collaboration"
        },
        formateur: "Pascal Forget",
        description: {
            fr: "<div><span style=\"font-size:11pt\">Objectifs de la formation :&nbsp;</span></div><ul><li><span style=\"font-family:calibri; font-size:11pt\">Découvrez le «&nbsp;WHY&nbsp;» de Microsoft 365</span></li><li><span style=\"font-family:calibri; font-size:11pt\">Un survol des outils importants de l'écosystème Microsoft 365 et comment ils peuvent aider vos équipes à être plus efficaces</span></li><li><span style=\"font-family:calibri; font-size:11pt\">Des pistes pour faire évoluer et moderniser la culture numérique de votre organisation.</span></li></ul>",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Target-1.jpg",
        categoriePrincipale: {
            id: "3b4669be-bc0b-ee11-8f6e-0022483d05a3",
            titre:{
                fr: "Compétences en collaboration",
                en: "Collaboration Skills"
            }
        }, 
        duration: "90 minutes",
        dateSession: "2024-01-09T12:00:00"
    },
    {
        id: "fc9ae3a3-cbfb-447d-8986-3d07f012c56c",
        langue : "fr",
        titreLong: {
            fr: "Le travail d'équipe et la collaboration avec Teams",
            en: "Teamwork and collaboration with Teams"
        },
        formateur: "Pascal Forget",
        description: {
            fr: "<div class=\"ExternalClass77826DD0D3DA46E59816356A294FC5FD\"><div><span style=\"font-family&#58;calibri;font-size&#58;11pt;\"><p>Collaborer avec Teams, c'est tout un changement pour beaucoup d'organisations, une révolution dans la façon de travailler et de partager des fichiers. Cette formation est là pour vous en faire connaître les avantages.</p><ul><li><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">​</span><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">Découvrez comment créer une structure d’espaces collaboratifs efficaces avec Microsoft Teams.</span></li><li><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">Découvrez comment choisir entre communiquer par équipe ou par canal.</span></li><li><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">Découvrez toutes les fonctions et paramètres incontournables pour créer et gérer vos équipes.</span></li></ul></span></div></div>",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Collaboration-1.jpg",
        categoriePrincipale: {
            id: "3b4669be-bc0b-ee11-8f6e-0022483d05a3",
            titre:{
                fr: "Compétences en collaboration",
                en: "Collaboration Skills"
            }
        }, 
        duration: "90 minutes",
        dateSession: "2024-01-09T12:00:00"
    },
    {
        id: "298dc1e0-e4f0-ed11-8848-0022483d05a3",
        langue : "en",
        titreLong: {
            fr: "Démystifiez la gestion des bases de données et Power Apps dans Microsoft 365",
            en: "Demystify the database management and Power Apps in Microsoft 365"
        },
        formateur: "Valère Drainville",
        description: {
            fr: "<div data-wrapper=\"true\" style=\"font-family:'Segoe UI','Helvetica Neue',sans-serif; font-size:9pt\"><div><div style=\"list-style-position:inside\"><strong>Objectifs:</strong></div>\n<ul><li style=\"list-style-position: inside;\"><span style=\"font-size:12pt\"><span style=\"font-family:&quot;Times New Roman&quot;,serif\"><span style=\"font-size:11.0pt\"><span style=\"font-family:&quot;Calibri&quot;,sans-serif\">Découvrez comment faire évaluer vos bases de données Microsoft Access</span></span></span></span></li><li style=\"list-style-position: inside;\"><span style=\"font-size:12pt\"><span style=\"font-family:&quot;Times New Roman&quot;,serif\"><span style=\"font-size:11.0pt\"><span style=\"font-family:&quot;Calibri&quot;,sans-serif\">Démystifiez les différents outils vous permettant gérer vos données dans Microsoft 365</span></span></span></span></li><li style=\"list-style-position: inside;\"><span style=\"font-size:12pt\"><span style=\"font-family:&quot;Times New Roman&quot;,serif\"><span style=\"font-size:11.0pt\"><span style=\"font-family:&quot;Calibri&quot;,sans-serif\">Découvrez les différences et choisir entre Microsoft Lists, Power Apps et Access.</span></span></span></span></li><li style=\"list-style-position: inside;\"><span style=\"font-size:12pt\"><span style=\"font-family:&quot;Times New Roman&quot;,serif\"><span style=\"font-size:11.0pt\"><span style=\"font-family:&quot;Calibri&quot;,sans-serif\">Découvrez comment vous pouvez automatiser vos processus d'affaires.</span></span></span></span></li></ul><br><strong><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Applications abordées pendant la présentation&nbsp;:</span></span></strong>\n<ul><li style=\"text-align:justify; margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Microsoft Acces</span></span></li><li style=\"text-align:justify; margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Microsoft Power Plateform</span></span><ul style=\"list-style-type:circle\"><li style=\"margin-left:8px; text-align:justify; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Power Apps</span></span></li><li style=\"margin-left:8px; text-align:justify; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Dataverse</span></span></li><li style=\"margin-left:8px; text-align:justify; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Power Automate</span></span></li><li style=\"margin-left:8px; text-align:justify; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Power Bi</span></span></li><li style=\"margin-left:8px; text-align:justify; margin-bottom:11px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"font-family:Calibri,sans-serif\">Dynamics 365</span></span></li></ul></li></ul></div></div>",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Brain-2.jpg",
        categoriePrincipale: {
            id: "76be1057-c541-ee11-be6e-000d3ae99ee1",
            titre:{
                fr: "Compétences avec Microsoft Power Platform",
                en: "Microsoft Power Platform Skills"
            }
        }, 
        duration: "90 minutes",
        dateSession: "2023-12-05T12:00:00"
    },
    {
        id: "286ecbf7-fdf0-ed11-8848-0022483d05a3",
        langue : "fr",
        titreLong: {
            fr: "Profitez au maximum de Microsoft Forms",
            en: "Get the most out of Microsoft Forms"
        },
        formateur: "Pascal Forget",
        description: {
            fr: "<div class=\"ExternalClassACA882670D6940F5A5495688638B4DE7\"><div><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">Forms, c'est beaucoup, beaucoup plus que des formulaires. C'est un outil simple et incontournable pour sonder sa clientèle, récolter des avis et des données, créer des tests de connaissance, faire des audits et des évaluations... Et bien plus!</span></div><div><div><ul><li><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">Apprenez comment créer et partager des formulaires et des questionnaires Forms</span></li><li><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">Découvrez plusieurs scénarios qui pourront vous aider à améliorer vos processus.</span></li><li><span style=\"font-family&#58;calibri;font-size&#58;11pt;\">Découvrez les fonctions et les paramètres incontournables de Forms.</span></li></ul></div></div></div>",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Humain-1.jpg",
        categoriePrincipale: {
            id: "3b4669be-bc0b-ee11-8f6e-0022483d05a3",
            titre:{
                fr: "Compétences en collaboration",
                en: "Collaboration Skills"
            }
        }, 
        duration: "90 minutes",
        dateSession: "2023-12-05T12:00:00"
    },
    {
        id: "47d89bc4-b68a-4e2a-8757-cdd762c6ce9b",
        langue : "fr",
        titreLong: {
            fr: "Les intournables pour bien démarrer avec les environnements Power Plateform",
            en: "The essentials for getting started with Power Platform environments"
        },
        formateur: "Valère Drainvill",
        description: {
            fr: "<div data-wrapper=\"true\" dir=\"ltr\" style=\"font-size:9pt;font-family:'Segoe UI','Helvetica Neue',sans-serif;\"><div><strong><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Cette formation s’adresse à toute personne qui veut créer et gérer un environnement Power Plateform ou Dynamics 365.</span></span></span></strong><ol><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Comprendre les environnements Power Plateform&nbsp;:</span></span></span><ol><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Quand et pourquoi créer un environnement;</span></span></span></li><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Gouvernance&nbsp;: Qui fait quoi?</span></span></span><ol><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Administrateur de la console d’administration Power Plateform;</span></span></span></li><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Administrateur système de l’environnement;</span></span></span></li><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Super-utilisateurs;</span></span></span></li><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Utilisateurs;</span></span></span></li></ol></li></ol></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Distinction entre environnement Bac à sable et Production;</span></span></span></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Création des environnements Plateform et Dynamics 365;</span></span></span></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Attribution des rôles administrateurs d’environnements;</span></span></span></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Gestion du groupe de sécurité de l’environnement;</span></span></span></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Comprendre et gérer la capacité des environnements;</span></span></span></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Gestion des copies et des sauvegardes;</span></span></span></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Gestion et attribution des licences par applications;</span></span></span></li><li style=\"margin-left:8px;list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Paramètres&nbsp;:</span></span></span><ol><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Audit;</span></span></span></li><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Intégration Outlook (Dynamics 365);</span></span></span></li><li style=\"margin-left:8px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Intégration Teams (Dynamics 365);</span></span></span></li><li style=\"margin-left:8px; margin-bottom:11px; list-style-position:inside\"><span style=\"font-size:11pt\"><span style=\"line-height:107%\"><span style=\"font-family:Calibri,sans-serif\">Langues d'utilisation.</span></span></span></li></ol></li></ol></div></div>",
            en: "Line 1\n Line2\n Line3\n Line 4"
        },
        imageUrl: "https://365e.pro/Formulaire/IMAGE/Tools-2.jpg",
        categoriePrincipale: {
            id: "76be1057-c541-ee11-be6e-000d3ae99ee1",
            titre:{
                fr: "Compétences avec Microsoft Power Platform",
                en: "Microsoft Power Platform Skills"
            }
        }, 
        duration: "90 minutes",
        dateSession: "2023-12-05T12:00:00"
    }
];

// Exemple de l'objet des catégories
// const coursesCategories = [
//     [
//         {
//             "id": "76be1057-c541-ee11-be6e-000d3ae99ee1",
//             "titre": {
//                 "fr": "Compétences avec Microsoft Power Platform",
//                 "en": "Microsoft Power Platform Skills"
//             }
//         },
//         {
//             "id": "3b4669be-bc0b-ee11-8f6e-0022483d05a3",
//             "titre": {
//                 "fr": "Compétences en collaboration",
//                 "en": "Collaboration Skills"
//             }
//         }
//     ]
// ];

export class ServiceCoursesMock implements IServiceCoursesProvider {
    public async getFeaturedCourses() {
        const apiUrl = process.env.REACT_APP_API_FEATURED_SESSIONS_URL ?? "";
        const apiSubscriptionKey =  process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        try {
            const fCourses= await axios.get(apiUrl, {
                headers: {
                    "Ocp-Apim-Subscription-Key": apiSubscriptionKey
                }
            });
            return (fCourses?.data) ? fCourses.data.sessions : [];
        } catch (error) {
            console.error(error);
        }
    }

    public async getCoursesByMonth(month: string) {
        // const searchCourse = coursesRes.filter((course) => course.date.indexOf(month) > -1);
        const apiUrl =  process.env.REACT_APP_API_SESSION_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        try {
            const coursesByMonth = await axios.get(apiUrl+"?month="+month, {
                headers: {
                    "Ocp-Apim-Subscription-Key": apiSubscriptionKey
                }
            });
            return (coursesByMonth.data) ? coursesByMonth.data.sessions : [];
        } catch (error) {
            console.error(error);
        }
    }

    public async getCourseById(courseId: string) {
        const apiUrl = process.env.REACT_APP_API_SESSION_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        try {
            const courseById = await axios.get(apiUrl+"/"+courseId, {
                headers: {
                    "Ocp-Apim-Subscription-Key": apiSubscriptionKey
                }
            });
            
            return (courseById.data) ? courseById.data : {};
        } catch (error) {
            console.error(error);
            const course = featuredCourses.filter((course) => course.id === courseId);
            const searchCourse = coursesRes.filter((course) => course.id === courseId);
            return (course.length > 0) ? course[0] : (searchCourse.length > 0) ? searchCourse[0] : {};
        }
    }

    public async getCoursesCategories() {
        const apiUrl = process.env.REACT_APP_API_CATEGORIES_URL ?? "";
        const apiSubscriptionKey =  process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        try {
            const coursesCategories = await axios.get(apiUrl, {
                headers: {
                    "Ocp-Apim-Subscription-Key": apiSubscriptionKey
                }
            });
            
            return (coursesCategories.data) ? coursesCategories.data.categoriesFormation : [];
        } catch (error) {
            console.error(error);
        }
    }

    public async getRegistrations(msal: IMsalContext, lang: any) {
        const apiUrl = process.env.REACT_APP_API_REGISTRATIONS_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY  ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, lang, (headers as any));
            const registrations = await axios.get(apiUrl, axiosConfig);
            return (registrations.data && registrations.status === 200) ? registrations.data.inscriptions : [];
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    public async getParticipations(msal: IMsalContext, lang: any, sessionId: string) {
        const apiUrl = (process.env.REACT_APP_API_PARTICIPATION_URL) ? process.env.REACT_APP_API_PARTICIPATION_URL.replace("{sessionId}", sessionId) : "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY  ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, lang, (headers as any));
            const participations = await axios.get(apiUrl, axiosConfig);
            return (participations.data && participations.status === 200) ? participations.data : {};
        } catch (error) {
            console.error(error);
            return {};
        }
    }

    public async getPresences(msal: IMsalContext, lang: any) {
        const apiUrl = process.env.REACT_APP_API_PRESENCES_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY  ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, lang, (headers as any));
            const presences = await axios.get(apiUrl, axiosConfig);
            
            return (presences.data && presences.status === 200) ? presences.data.presences : [];
        } catch (error) {
            console.error(error);
            return [];
        }
    }

    public async getTypesSubscription(msal: IMsalContext) {
        const apiUrl =  process.env.REACT_APP_API_SUBSCRIPTION_TYPES ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const typesSubscription = await axios.get(apiUrl, {headers});
            return (typesSubscription.data) ? typesSubscription.data : [];
        } catch (error) {
            console.error(error);
        }
    }

    public async sendSubscription(msal: IMsalContext, dataToSend: any) {
        const apiUrl =  process.env.REACT_APP_API_SUBSCRIPTION_SUBMIT_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, (headers as any));
            const newSubscription = await axios.post(apiUrl, dataToSend, axiosConfig);
            console.log("newSubscription: ", newSubscription);
            return (newSubscription && newSubscription.status !== 500) ? newSubscription.data : {error: newSubscription.data};
        } catch (error) {
            console.error(error);
        }
    }

    public async getSubscriptions(msal: IMsalContext) {
        const apiUrl =  process.env.REACT_APP_API_SUBSCRIPTION_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, (headers as any));
            const coursesSubscriptions = await axios.get(apiUrl, axiosConfig);
            return (coursesSubscriptions.data) ? coursesSubscriptions.data : [];
        } catch (error) {
            console.error(error);
        }
    }

    public async createSubscription(msal: IMsalContext) {
        const apiUrl = process.env.REACT_APP_API_CREATE_SUBSCRIPTION_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY  ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, (headers as any));
            console.log("lang: ");
            const coursesSubscription = await axios.post(apiUrl, {"langue": msal.accounts[0].idTokenClaims?.extension_communicationLangue}, axiosConfig);
            return (coursesSubscription && coursesSubscription.status !== 500) ? coursesSubscription.data : null;
        } catch (error) {
            console.error(error);
        }
    }

    public async updateSubscription(msal: IMsalContext, invitationCode: string) {
        const apiUrl = process.env.REACT_APP_API_SUBSCRIPTIONS_ROOT_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, (headers as any));
            console.log(`call to API ${apiUrl}${invitationCode}/update`);
            console.log("data to update: ", {"name": msal.accounts[0].idTokenClaims?.given_name, "LastName": msal.accounts[0].idTokenClaims?.family_name, "DisplayName": msal.accounts[0].idTokenClaims?.name})
            const updatedSubscription = await axios.put(
                `${apiUrl}${invitationCode}/update`,
                {
                    "name": msal.accounts[0].idTokenClaims?.given_name,
                    "LastName": msal.accounts[0].idTokenClaims?.family_name,
                    "DisplayName": msal.accounts[0].idTokenClaims?.name
                },
                axiosConfig
            );
            return updatedSubscription;
        } catch (error) {
            console.error(error);
        }
    }

    public async assistSession(msal: IMsalContext, sessionId: string, subscriptionId: string) {
        const apiUrl = process.env.REACT_APP_API_SESSIONS_ROOT_URL ?? "";
        const subUrl = process.env.REACT_APP_API_ASSIST_SUB_URL ?? "";
        const apiSubscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY ?? "";
        const headers = {
            "Ocp-Apim-Subscription-Key": apiSubscriptionKey
        };
        try {
            const axiosConfig = await this.getAuthorizedAxiosConfig(msal, (headers as any));
            console.log(`call to API ${apiUrl}${sessionId}/${subUrl}`);
            console.log("subscriptionId: ", subscriptionId);
            const updatedSubscription = await axios.post(
                `${apiUrl}${sessionId}/${subUrl}`,
                {
                    "abonneId": subscriptionId
                },
                axiosConfig
            );
            return updatedSubscription;
        } catch (error) {
            console.error(error);
        }
    }

    private async getAuthorizedAxiosConfig (
        context: IMsalContext,
        headers?: AxiosResponseHeaders,
        config?: AxiosRequestConfig
    ): Promise<AxiosRequestConfig> {
        
        let accessToken;
        let scopes: any = [
            process.env.REACT_APP_SCOPE
            ,...loginRequest.scopes
        ];
        try {
          const response = await context.instance.acquireTokenSilent({
            scopes: scopes,
            forceRefresh: false,
            account: context.accounts[0],
          });
          accessToken = response.accessToken;
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            await context.instance.acquireTokenRedirect({
              scopes: scopes,
              account: context.accounts[0],
            });
          } else {
            // Error was not related to needing interaction
            throw error;
          }
        }
      
        return {
          ...config,
          withCredentials: true,
          validateStatus: () => true,
          headers: {
            ...headers,
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            Authorization: `Bearer ${accessToken}`,
          },
        };
    }
}